import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StatusDate from '../StatusDate';
import IconStand from '../IconStand';
import ShipmentStatusIcon from './ShipmentStatusIcon';
import { lastEventShape } from '../statusHelper';
import { Heading, NormalText } from '../../StyledComponents';
import styles from './ShipmentStatus.module.scss';

class ShipmentStatus extends React.PureComponent {
  render() {
    const {
      message,
      icon,
      date,
      description,
      showIcon,
      isMobile,
      language,
      designSettings: {
        bodyHeadingsColor,
        bodyTextColor,
        iconBackgroundColor,
        iconColor,
        headingFontSize,
        headingFont,
        bodyFontSize,
        bodyFont,
      },
      locale,
    } = this.props;

    return (
      <div styleName={classNames('shipment-status', { mobile: isMobile })}>
        {showIcon && (
          <IconStand size={isMobile ? 116 : 186} iconBackgroundColor={iconBackgroundColor}>
            <ShipmentStatusIcon name={icon} size={isMobile ? 48 : 64} fill={iconColor} />
          </IconStand>
        )}
        <div styleName="info" lang={language}>
          <div className={styles.name}>
            <Heading
              type="headingPrimary"
              isMobile={isMobile}
              fontSize={headingFontSize}
              font={headingFont}
              color={bodyHeadingsColor}
            >
              {message}
            </Heading>
          </div>
          {description && (
            <div styleName="description">
              <NormalText
                isMobile={isMobile}
                type="bodyPrimary"
                font={bodyFont}
                fontSize={bodyFontSize}
                color={bodyTextColor}
              >
                {description}
              </NormalText>
            </div>
          )}
          {date && (
            <StatusDate
              isMobile={isMobile}
              fontSize={bodyFontSize}
              font={bodyFont}
              date={date}
              color={bodyTextColor}
              locale={locale}
            />
          )}
        </div>
      </div>
    );
  }
}

ShipmentStatus.propTypes = {
  ...lastEventShape,
  showIcon: PropTypes.bool,
  isMobile: PropTypes.bool,
  designSettings: PropTypes.shape({
    bodyHeadingsColor: PropTypes.string,
    bodyTextColor: PropTypes.string,
    iconBackgroundColor: PropTypes.string,
    iconColor: PropTypes.string,
    headingFont: PropTypes.string,
    headingFontSize: PropTypes.string,
    bodyFont: PropTypes.string,
    bodyFontSize: PropTypes.string,
  }),
};

export default ShipmentStatus;
